import { createFileRoute } from '@tanstack/react-router';
import { AppCard, PageHeader } from '@repo/ui';

export const Route = createFileRoute('/about')({
  component: AboutPage,
});

function AboutPage() {
  return (
    <div className="container mx-auto max-w-3xl px-4 py-8">
      <PageHeader title="About" description="Learn more about this template." />

      <div className="grid gap-4">
        <AppCard title="Stack">
          <ul className="space-y-1 text-sm text-default-600">
            <li>⚡ Turborepo monorepo</li>
            <li>☁️ Convex realtime backend</li>
            <li>⚛️ React + Vite</li>
            <li>🔀 TanStack Router (file-based)</li>
            <li>📡 TanStack Query (via Convex adapter)</li>
            <li>🗃️ TanStack Store</li>
            <li>🎨 Tailwind CSS design system</li>
            <li>🔍 Sentry error tracking</li>
            <li>🧪 Vitest + Playwright</li>
            <li>💉 Lightweight DI container</li>
            <li>📱 Capacitor-ready (mobile)</li>
          </ul>
        </AppCard>

        <AppCard title="Getting Started">
          <ol className="list-decimal space-y-2 pl-4 text-sm text-default-600">
            <li>
              Run <code className="rounded bg-default-100 px-1">bun install</code>
            </li>
            <li>
              Copy <code className="rounded bg-default-100 px-1">.env.local.example</code> →{' '}
              <code className="rounded bg-default-100 px-1">.env.local</code>
            </li>
            <li>
              Run <code className="rounded bg-default-100 px-1">bunx convex dev</code> from{' '}
              <code className="rounded bg-default-100 px-1">packages/backend</code>
            </li>
            <li>
              Run <code className="rounded bg-default-100 px-1">bun run dev</code> from the root
            </li>
          </ol>
        </AppCard>
      </div>
    </div>
  );
}
